import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowWidgetDown",
  "use": "icon-arrowWidgetDown-usage",
  "viewBox": "0 0 24 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 22\" id=\"icon-arrowWidgetDown\"><g opacity=\"0.5\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M20.3811 19.9746C20.3811 9.77858 11.9384 1.51307 1.52393 1.51307\" stroke-dasharray=\"2 4\" /><path d=\"M18.2856 18.435L20.3809 20.4863L22.4761 18.435\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol